module.exports = __webpack_public_path__ + "static/media/out-right-front.72ef5998.png";